import React from 'react';
import Select from 'react-select';
import { FormGroup } from 'reactstrap';
import HelperText from '../@core/components/helper-text';
import { useThemeColors } from '../utility/hooks/useThemeColors';
import { Label } from './Forms';
import LabelValueWrapper from './Layout/LabelValueWrapper';

const SelectInput = ({
	name,
	id,
	options = [],
	disabled,
	placeholder,
	caption,
	isRequired,
	errors,
	value,
	onChange,
	onBlur,
	noInputWrapper,
	noOptionsMessage,
	returnAllEvent = false,
	readOnly,
	inputProps,
	...rest
}) => {
	const colors = useThemeColors();
	let isValid = false;
	isValid = !errors;

	const optionsChange = (event) => {
		const result = returnAllEvent ? event : event.value;
		onChange({ name, value: result });
	};

	const customStyles = {
		control: (base, state) => ({
			...base,
			borderColor: state.isFocused ? '#ddd' : isValid ? '#ddd' : 'red',
			'&:hover': {
				borderColor: state.isFocused ? '#ddd' : isValid ? '#ddd' : 'red'
			},
			fontFamily: 'Poppins Medium',
			color: colors.gray[700]
		}),
		singleValue: (base) => ({
			...base,
			color: '#445065 !important',
			fontFamily: 'Poppins SemiBold',
			fontSize: '14px'
		})
	};

	const selectedValue = options.find((option) => {
		return value === option.value;
	}) || null;

	if (readOnly) {
		const showValue = options?.filter((option) => option.value === value);
		const label = showValue && showValue[0] ? showValue[0].label : '-';
		return <LabelValueWrapper value={label} title={caption} />;
	}

	return (
		<FormGroup {...rest}>
			{!!caption && <Label isRequired={isRequired}>{caption}</Label>}
			<Select
				id={id}
				styles={customStyles}
				name={name}
				options={options}
				className="basic-single"
				classNamePrefix="select"
				isDisabled={disabled}
				placeholder={placeholder ?? ''}
				noOptionsMessage={() =>
					noOptionsMessage ? noOptionsMessage : 'Sin opciones'
				}
				invalid={errors && true}
				onChange={optionsChange}
				value={returnAllEvent ? value : selectedValue }
				onBlur={onBlur}
				{...inputProps}
			/>
			<HelperText error={errors} />
		</FormGroup>
	);
};

export default SelectInput;
